export enum TestPlanStepStatus {
  Passed = 'passed',
  Failed = 'failed',
  Blocked = 'blocked',
}
